import { render, staticRenderFns } from "./EntitlementAdd.vue?vue&type=template&id=3187e1f3&"
import script from "./EntitlementAdd.vue?vue&type=script&lang=ts&"
export * from "./EntitlementAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3187e1f3')) {
      api.createRecord('3187e1f3', component.options)
    } else {
      api.reload('3187e1f3', component.options)
    }
    module.hot.accept("./EntitlementAdd.vue?vue&type=template&id=3187e1f3&", function () {
      api.rerender('3187e1f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entitlements/EntitlementAdd.vue"
export default component.exports